import type { LanguageCode } from '../languages'
import { en, type Messages } from './en'
import { fr } from './fr'
import { es } from './es'
import { pt } from './pt'
import { nl } from './nl'

/**
 * All catalogs keyed by locale. `satisfies Record<LanguageCode, Messages>`
 * guarantees every supported language has a catalog (and only supported
 * languages do) — drift between LANGUAGES and the catalogs is a build error.
 */
export const catalogs = { en, fr, es, pt, nl } satisfies Record<LanguageCode, Messages>

export type { Messages, MessageKey } from './en'
